
// import moment from 'moment'
export default {
  // 消息cell
  name: 'MessageCell',
  components: {},
  props: {
    data: Object,
    dataIndex: [String, Number]
  },
  data: function data() {
    return {};
  },

  computed: {
    typeObj: function typeObj() {
      var typesObj = {
        leads: {
          icon: 'wk wk-leads',
          color: '#6995FF',
          type: 'leads'
        },
        customer: {
          icon: 'wk wk-customer',
          color: '#6995FF',
          type: 'customer'
        },
        contacts: {
          icon: 'wk wk-contacts',
          color: '#6995FF',
          type: 'contacts'
        },
        business: {
          icon: 'wk wk-business',
          color: '#6995FF',
          type: 'business'
        },
        contract: {
          icon: 'wk wk-contract',
          color: '#6995FF',
          type: 'contract'
        },
        receivables: {
          icon: 'wk wk-receivables',
          color: '#6995FF',
          type: 'receivables'
        },
        product: {
          icon: 'wk wk-product',
          color: '#6995FF',
          type: 'product'
        },
        log: {
          icon: 'wk wk-log',
          color: '#6995FF',
          type: 'log'
        },
        examine: {
          icon: 'wk wk-approve',
          color: '#6995FF',
          type: 'examine'
        },
        task: {
          icon: 'wk wk-o-task',
          color: '#6995FF',
          type: 'task'
        },
        announcement: {
          icon: 'wk wk-announcement',
          color: '#6995FF',
          type: 'announcement'
        },
        schedule: {
          icon: 'wk wk-schedule',
          color: '#6995FF',
          type: 'schedule'
        },
        invoice: {
          icon: 'wk wk-invoice',
          color: '#6995FF',
          type: 'invoice'
        }

        // 1 任务 2 日志 3 oa审批 4公告 5 日程 7 客户管理
      };var key = '';
      if (this.data.label && this.data.label <= 5) {
        key = ['task', 'log', 'examine', 'announcement', 'schedule'][this.data.label - 1];
      } else {
        if ([1, 2, 3, 27].includes(this.data.type)) {
          key = 'task';
        } else if ([4, 5, 34].includes(this.data.type)) {
          key = 'log';
        } else if ([6, 7, 8, 2500].includes(this.data.type)) {
          key = 'examine';
        } else if ([9].includes(this.data.type)) {
          key = 'announcement';
        } else if ([12, 13, 23, 11, 30, 33].includes(this.data.type)) {
          key = 'contract';
        } else if ([15, 16, 2700, 14].includes(this.data.type)) {
          key = 'receivables';
        } else if ([17, 1500, 21, 29, 32].includes(this.data.type)) {
          key = 'customer';
        } else if ([18, 1700].includes(this.data.type)) {
          key = 'contacts';
        } else if ([19, 1900].includes(this.data.type)) {
          key = 'leads';
        } else if ([20, 2100].includes(this.data.type)) {
          key = 'product';
        } else if ([22, 28, 31].includes(this.data.type)) {
          key = 'business';
        } else if ([25, 26, 24].includes(this.data.type)) {
          key = 'invoice';
        } else if ([10].includes(this.data.type)) {
          key = 'schedule';
        }
      }

      return typesObj[key];
    },
    leftContent: function leftContent() {
      return {
        1: this.data.user_name + '\u5C06',
        2: this.data.user_name + '\u9080\u8BF7\u60A8\u53C2\u4E0E',
        3: this.data.user_name + '\u5C06',
        4: this.data.user_name + '\u56DE\u590D\u4E86\u60A8\u7684',
        5: this.data.user_name + '\u5C06\u65E5\u5FD7',
        6: this.data.user_name + '\u63D0\u4EA4 \u5BA1\u6279\uFF0C\u8BF7\u53CA\u65F6\u5904\u7406\u3002',

        7: this.data.user_name + '\u62D2\u7EDD\u60A8\u7684',
        8: this.data.user_name + '\u5DF2\u7ECF\u5BA1\u6838\u901A\u8FC7\u60A8\u7684',
        9: '\u60A8\u6709\u4E00\u4E2A\u65B0\u516C\u544A',
        10: this.data.user_name + '\u9080\u8BF7\u60A8\u53C2\u4E0E',

        12: this.data.user_name + '\u62D2\u7EDD\u60A8\u7684',
        13: this.data.user_name + '\u5DF2\u7ECF\u5BA1\u6838\u901A\u8FC7\u60A8\u7684',
        14: this.data.user_name + '\u63D0\u4EA4 ',
        15: this.data.user_name + '\u62D2\u7EDD\u60A8\u7684',
        16: this.data.user_name + '\u5DF2\u7ECF\u5BA1\u6838\u901A\u8FC7\u60A8\u7684',
        17: this.data.user_name + '\u5BFC\u5165\u5BA2\u6237\u6570\u636E\uFF0C' + this.getImportContent(this.data),
        1500: this.data.user_name + '\u53D6\u6D88\u5BFC\u5165\u5BA2\u6237\u6570\u636E\uFF0C\u5DF2\u5BFC\u5165\uFF0C' + this.getImportContent(this.data),
        18: this.data.user_name + '\u5BFC\u5165\u8054\u7CFB\u4EBA\u6570\u636E\uFF0C' + this.getImportContent(this.data),
        1700: this.data.user_name + '\u53D6\u6D88\u5BFC\u5165\u8054\u7CFB\u4EBA\u6570\u636E\uFF0C\u5DF2\u5BFC\u5165' + this.data.title + '\u6761\uFF0C' + this.getImportContent(this.data),
        19: this.data.user_name + '\u5BFC\u5165\u7EBF\u7D22\u6570\u636E\uFF0C' + this.getImportContent(this.data),
        1900: this.data.user_name + '\u53D6\u6D88\u5BFC\u5165\u7EBF\u7D22\u6570\u636E\uFF0C\u5DF2\u5BFC\u5165\uFF0C' + this.getImportContent(this.data),
        20: this.data.user_name + '\u5BFC\u5165\u4EA7\u54C1\u6570\u636E\uFF0C' + this.getImportContent(this.data),
        2100: this.data.user_name + '\u53D6\u6D88\u5BFC\u5165\u4EA7\u54C1\u6570\u636E\uFF0C\u5DF2\u5BFC\u5165\uFF0C' + this.getImportContent(this.data),
        22: this.data.user_name + '\u5C06\u60A8\u6DFB\u52A0\u4E3A\u5546\u673A',
        21: this.data.user_name + '\u5C06\u60A8\u6DFB\u52A0\u4E3A\u5BA2\u6237',
        23: this.data.user_name + '\u5C06\u60A8\u6DFB\u52A0\u4E3A\u5408\u540C',
        2500: this.data.user_name + '\u63D0\u4EA4\u4E86',
        11: this.data.user_name + '\u63D0\u4EA4\u4E86',
        2700: this.data.user_name + '\u63D0\u4EA4\u4E86',
        28: this.data.user_name + '\u9000\u51FA\u4E86\u60A8\u5546\u673A',
        29: this.data.user_name + '\u9000\u51FA\u4E86\u60A8\u5BA2\u6237',
        30: this.data.user_name + '\u9000\u51FA\u4E86\u60A8\u5408\u540C',
        31: this.data.user_name + '\u5C06\u60A8\u79FB\u51FA\u4E86\u5546\u673A',
        32: this.data.user_name + '\u5C06\u60A8\u79FB\u51FA\u4E86\u5BA2\u6237',
        33: this.data.user_name + '\u5C06\u60A8\u79FB\u51FA\u4E86\u5408\u540C',
        34: this.data.user_name + '\u56DE\u590D\u4E86\u60A8\u8BC4\u8BBA\u7684\u65E5\u5FD7',
        25: this.data.user_name + '\u62D2\u7EDD\u60A8\u7684',
        26: this.data.user_name + '\u5DF2\u7ECF\u5BA1\u6838\u901A\u8FC7\u60A8\u7684',
        24: this.data.user_name + '\u63D0\u4EA4\u4E86',
        27: this.data.user_name + '\u9879\u76EE\u4EFB\u52A1\u5BFC\u5165\u6570\u636E\uFF0C' + this.getImportContent(this.data)
      }[this.data.type];
    },
    centerCotent: function centerCotent() {
      // 导入提示与其他不一样
      if (this.isImportType) {
        // title 是总数 content 是错误数据 valid 错误文件是否有效 1 有效 0 失效
        var list = this.data.content.split(',') || [];
        var errSize = Number(list[3] || 0);
        if (errSize > 0) {
          return this.data.valid === 0 ? '已失效' : '点击下载错误数据';
        }
        return '';
      } else {
        return '\u300A' + this.data.title + '\u300B';
      }
    },
    isInvalid: function isInvalid() {
      if (this.isImportType) {
        // title 是总数 content 是错误数据 valid 错误文件是否有效 1 有效 0 失效
        return this.data.valid == 0;
      } else {
        return false;
      }
    },


    /**
     * 是导入type
     */
    isImportType: function isImportType() {
      return this.data.type >= 17 && this.data.type <= 20 || this.data.type == 27;
    },
    rightContent: function rightContent() {
      return {
        1: '\u4EFB\u52A1\u5206\u914D\u7ED9\u60A8\uFF0C\u8BF7\u53CA\u65F6\u67E5\u770B',
        2: '\u4EFB\u52A1\uFF0C\u8BF7\u53CA\u65F6\u67E5\u770B',
        3: '\u4EFB\u52A1\u6807\u8BB0\u7ED3\u675F',
        4: '\u65E5\u5FD7\uFF1A\u201C' + this.data.content + '\u201D\uFF0C\u8BF7\u53CA\u65F6\u67E5\u770B',
        5: '\u53D1\u9001\u7ED9\u60A8\uFF0C\u8BF7\u53CA\u65F6\u67E5\u770B',
        6: '\uFF0C\u8BF7\u53CA\u65F6\u67E5\u770B',
        7: '\uFF0C\u62D2\u7EDD\u7406\u7531\uFF1A\u201C' + this.data.content + '\u201D\uFF0C\u8BF7\u53CA\u65F6\u5904\u7406',
        8: '\uFF0C\u8BF7\u53CA\u65F6\u67E5\u770B',
        9: '\uFF0C\u8BF7\u53CA\u65F6\u67E5\u770B',
        10: '\u7684\u65E5\u7A0B\uFF0C' + this.getStartTime(this.data.content) + '\u8BF7\u53CA\u65F6\u67E5\u770B',
        12: '\u5408\u540C\u5BA1\u6279\uFF0C\u62D2\u7EDD\u7406\u7531\uFF1A\u201C' + this.data.content + '\u201D\uFF0C\u8BF7\u53CA\u65F6\u5904\u7406',
        13: '\u5408\u540C\uFF0C\u8BF7\u53CA\u65F6\u67E5\u770B',
        14: ' \u56DE\u6B3E\u5BA1\u6279\u5F85\u60A8\u5904\u7406\u3002',
        15: '\u56DE\u6B3E\u5BA1\u6279\uFF0C\u62D2\u7EDD\u7406\u7531\uFF1A\u201C' + this.data.content + '\u201D\uFF0C\u8BF7\u53CA\u65F6\u5904\u7406',
        16: '\u56DE\u6B3E\uFF0C\u8BF7\u53CA\u65F6\u67E5\u770B',
        17: '',
        1500: '',
        18: '',
        1700: '',
        19: '',
        1900: '',
        20: '',
        2100: '',
        22: '\u7684\u6210\u5458',
        21: '\u7684\u6210\u5458',
        23: '\u7684\u6210\u5458',
        2500: '\uFF0C\u8BF7\u53CA\u65F6\u5904\u7406',
        11: '\u5408\u540C\u5BA1\u6279\uFF0C\u8BF7\u53CA\u65F6\u5904\u7406',
        2700: '\u56DE\u6B3E\u5BA1\u6279\uFF0C\u8BF7\u53CA\u65F6\u5904\u7406',
        28: '\u7684\u56E2\u961F',
        29: '\u7684\u56E2\u961F',
        30: '\u7684\u56E2\u961F',
        31: '\u7684\u56E2\u961F',
        32: '\u7684\u56E2\u961F',
        33: '\u7684\u56E2\u961F',
        34: '\uFF1A\u201C' + this.data.content + '\u201D\uFF0C\u8BF7\u53CA\u65F6\u67E5\u770B',
        25: '\u53D1\u7968\u5BA1\u6279\uFF0C\u62D2\u7EDD\u7406\u7531\uFF1A\u201C' + this.data.content + '\u201D\uFF0C\u8BF7\u53CA\u65F6\u5904\u7406',
        26: '\u53D1\u7968\uFF0C\u8BF7\u53CA\u65F6\u67E5\u770B',
        24: '\u53D1\u7968\u5BA1\u6279\uFF0C\u8BF7\u53CA\u65F6\u5904\u7406',
        27: ''
      }[this.data.type];
    }
  },
  watch: {},
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {},

  methods: {
    enterDetail: function enterDetail() {
      if (this.isInvalid) {
        return;
      }

      // 是导入提醒
      if (this.isImportType) {
        this.$emit('download', this.data, this.dataIndex);
      } else {
        // 未读触发读
        if (this.data.is_read == 0) {
          this.$emit('read', this.data.message_id, this.dataIndex);
        }
        this.$emit('detail', this.typeObj.type, this.data.action_id, this.dataIndex, this.data);
      }
    },


    /**
     * 标记已读
     */
    messageReadClick: function messageReadClick() {
      this.$emit('read', this.data.message_id, this.dataIndex);
    },


    /**
     * 消息删除
     */
    messageDeleteClick: function messageDeleteClick() {
      this.$emit('delete', this.data.message_id, this.dataIndex);
    },


    /**
     * 日程提醒，多长时间后开始
     */
    getStartTime: function getStartTime(content) {
      if (this.data.type != 10) {
        return;
      }
      var timeObj = content || { type: 0, value: '' };

      var dataValue = '';
      if (!timeObj.type) {
        dataValue = '';
      } else {
        dataValue = '将于' + timeObj.value + ['', '分钟', '小时', '天'][timeObj.type] + '后开始, ';
      }
      return dataValue;
    },
    getImportContent: function getImportContent(_ref) {
      var title = _ref.title,
          content = _ref.content;

      var countList = [17, 1500, 18, 1700, 19, 1900, 20, 2100, 50, 27];
      if (!countList.includes(this.data.type)) {
        return;
      }
      var list = content.split(',') || [];

      var updateSize = Number(list[1] || '0');
      var errSize = Number(list[3] || '0');
      return '\u8986\u76D6' + updateSize + '\u6761\uFF0C\u5BFC\u5165\u6210\u529F' + Number(list[2] || '0') + '\u6761\uFF0C\u5BFC\u5165\u5931\u8D25' + errSize + '\u6761\u3002';
    }
  }
};